/**
 * Display helpers for profile list rows.
 * Builds human-readable labels and one-line summaries (email for parents,
 * campus/level/class for students).
 */
import type { Profile } from "@spork/s4p-server-sdk";

import { i18n } from "../../../i18n";
import { SCHOOL_PLACEMENT_FIELD_CODES } from "../config/profileFormGroups";

export function formatReadonlyFieldSummary(
    profile: Profile,
    fieldCodes: readonly string[],
    separator = " · ",
): string | undefined {
    const parts = fieldCodes
        .map((fieldCode) => profile.custom_fields[fieldCode]?.text)
        .filter((value): value is string => Boolean(value?.trim()));

    return parts.length > 0 ? parts.join(separator) : undefined;
}

export function formatProfileSummary(profile: Profile): string | undefined {
    if (profile.role === "parent") {
        return profile.email ?? undefined;
    }

    return formatReadonlyFieldSummary(profile, SCHOOL_PLACEMENT_FIELD_CODES);
}

export function getProfileLabel(profile: Profile): string {
    return (
        `${profile.first_name ?? ""} ${profile.last_name ?? ""}`.trim() ||
        i18n.t("profile.placeholder")
    );
}
